import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RatingModel } from 'Modules'

export const ratingApi = {
	createRating: async (data: RatingModel) => {
		const res = await axiosDS().post<RatingModel>(urls.modules.rating.create, {
			evaluation: data,
		})
		return res.data
	},
}
